import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";

export default function Logo({ size = "md", className = "", to = "/" }) {
  const { t } = useApp();
  const sizes = { sm: "h-8", md: "h-11", lg: "h-16", xl: "h-24" };
  const cls = sizes[size] || sizes.md;
  // Explicit width/height reserves layout space (no CLS) and matches the
  // largest displayed logo (192px @ 2x DPR = 384px source).
  const img = (
    <picture>
      <source type="image/webp" srcSet="/brand/logo-192.webp 1x, /brand/logo-384.webp 2x" />
      <img
        src="/brand/logo-192.png"
        srcSet="/brand/logo-192.png 1x, /brand/logo-384.png 2x"
        width="192"
        height="192"
        alt="Coiffeur Tattoo 01&Co."
        className={`${cls} w-auto object-contain select-none`}
        draggable={false}
      />
    </picture>
  );
  if (!to) return <div className={className}>{img}</div>;
  return <Link to={to} className={`inline-flex items-center ${className}`} aria-label={t("aria_logo_home")}>{img}</Link>;
}

